import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
    templateUrl: './function-na-modal.component.html'
})
export class FunctionalityNAModalComponent implements OnInit {


   
    constructor(
        public activeModal: NgbActiveModal,
    ) { }

    ngOnInit() {
        
        
    }

   
}